module.exports = __webpack_public_path__ + "static/media/logo-sucupiranorte.2c892b1c.png";